module.exports = __webpack_public_path__ + "static/maison-interieur-23bb40025de6a38eada0a0cdd7718e38.jpg";